import React, {ReactNode, createContext, useMemo} from "react";

import {DateString} from "@globals/types/utilityTypes";
import {useUser} from "@globals/user";

import {getSocialProofDetails} from "./getSocialProofDetails";
import {SocialProofContextType} from "./interfaces";
import {useSocialProof} from "./useSocialProof";

export const SocialProofContext = createContext<SocialProofContextType>(
  {} as SocialProofContextType
);

type SocialProofConfigProviderProps = {
  children: ReactNode;
  inviteKey?: string;
  selectedDate?: DateString;
};

export function SocialProofConfigProvider({
  children,
  inviteKey,
  selectedDate,
}: SocialProofConfigProviderProps): JSX.Element {
  const {user} = useUser();
  const {socialProofs = {}} = useSocialProof(
    inviteKey,
    selectedDate,
    user?.selected_location.id
  );

  const memoizedConfig = useMemo(() => {
    return {
      socialProofs,
      getSocialProofDetails: (itemId: number) => {
        const proofType = socialProofs?.[itemId];
        if (proofType) {
          return getSocialProofDetails(proofType, user?.company.name);
        }
        return null;
      },
    };
  }, [socialProofs]);

  return (
    <SocialProofContext.Provider value={memoizedConfig}>
      {children}
    </SocialProofContext.Provider>
  );
}
